/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type { FindProductionSitesByBusinessPartnersQueryResponse } from "../types/FindProductionSitesByBusinessPartners.ts"

export const findProductionSitesByBusinessPartnersQueryKey = () =>
  [
    { url: "/v1/production-site/find-production-sites-by-business-partners" },
  ] as const

export type FindProductionSitesByBusinessPartnersQueryKey = ReturnType<
  typeof findProductionSitesByBusinessPartnersQueryKey
>

/**
 * @summary Find production sites by business partners
 * {@link /v1/production-site/find-production-sites-by-business-partners}
 */
export async function findProductionSitesByBusinessPartners(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindProductionSitesByBusinessPartnersQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/production-site/find-production-sites-by-business-partners`,
    ...requestConfig,
  })
  return res
}

export function findProductionSitesByBusinessPartnersQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = findProductionSitesByBusinessPartnersQueryKey()
  return queryOptions<
    ResponseConfig<FindProductionSitesByBusinessPartnersQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindProductionSitesByBusinessPartnersQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return findProductionSitesByBusinessPartners(config)
    },
  })
}

/**
 * @summary Find production sites by business partners
 * {@link /v1/production-site/find-production-sites-by-business-partners}
 */
export function useFindProductionSitesByBusinessPartners<
  TData = ResponseConfig<FindProductionSitesByBusinessPartnersQueryResponse>,
  TQueryData = ResponseConfig<FindProductionSitesByBusinessPartnersQueryResponse>,
  TQueryKey extends QueryKey = FindProductionSitesByBusinessPartnersQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindProductionSitesByBusinessPartnersQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey =
    queryOptions?.queryKey ?? findProductionSitesByBusinessPartnersQueryKey()

  const query = useQuery(
    {
      ...findProductionSitesByBusinessPartnersQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
